/**
 * ProfessionCard Component
 * Displays a profession card with icon, name, description, and professional count
 */

import { Badge } from '@shared/components/ui/badge'
import { Card } from '@shared/components/ui/card'
import type { Profession } from '@shared/types'
import { BriefcaseBusiness, Users } from 'lucide-react'

// ============================================================================
// Types
// ============================================================================

interface ProfessionCardProps {
  profession: Profession
  onClick?: (profession: Profession) => void
}

// ============================================================================
// Component
// ============================================================================

export function ProfessionCard({ profession, onClick }: ProfessionCardProps) {
  const handleClick = () => {
    onClick?.(profession)
  }

  return (
    <Card
      className="px-6 pt-4 pb-2 hover:bg-secondary/25 active:animate-pulse active:bg-secondary/50 transition-shadow cursor-pointer"
      onClick={handleClick}
    >
      <div className="space-y-4">
        {/* Header with name and count */}
        <div className="flex items-center gap-3">
          <BriefcaseBusiness size={32} className="text-primary" />
          <h3 className="text-xl font-semibold group-hover:text-primary transition-colors">
            {profession.name}
          </h3>
          {/* <Badge variant="secondary" className="ml-2">
            <Users className="h-3 w-3 mr-1" />
            {profession.count}
          </Badge> */}
        </div>

        {/* Description */}
        {profession.description && (
          <p className="text-sm text-muted-foreground line-clamp-2">
            {profession.description}
          </p>
        )}

        {/* Footer with count text */}
        <div className="pt-2 border-t border-muted-foreground/50">
          <p className="text-xs text-muted-foreground text-right">
            {profession.count === 0 && 'Sin profesionales disponibles'}
            {profession.count === 1 && '1 profesional disponible'}
            {profession.count > 1 && `${profession.count} profesionales disponibles`}
          </p>
        </div>
      </div>
    </Card>
  )
}

// ============================================================================
// Loading Skeleton
// ============================================================================

export function ProfessionCardSkeleton() {
  return (
    <Card className="p-6">
      <div className="space-y-4 animate-pulse">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div className="text-xl font-semibold group-hover:text-primary transition-colors">Plomero</div>
          <Badge variant="secondary" className="ml-2">
            <Users className="h-3 w-3 mr-1" />            1          </Badge>
        </div>

        {/* Description lines */}
        <p className="text-sm text-muted-foreground line-clamp-2">
          Profesionales en instalaci n y reparaci n de sistemas de plomer a
        </p>
        <div className="pt-2 border-t">
          <p className="text-xs text-muted-foreground">
            Sin profesionales disponibles
          </p>
        </div>
      </div>
    </Card>

    // return (
    // <Card className="p-6">
    //   <div className="space-y-4 animate-pulse">
    //     {/* Header */}
    //     <div className="flex items-start justify-between">
    //       <div className="h-6 bg-muted rounded w-2/3" />
    //       <div className="h-6 bg-muted rounded w-12 ml-2" />
    //     </div>

    //     {/* Description lines */}
    //     <div className="space-y-2">
    //       <div className="h-4 bg-muted rounded w-full" />
    //       <div className="h-4 bg-muted rounded w-4/5" />
    //     </div>

    //     {/* Footer */}
    //     <div className="pt-2 border-t">
    //       <div className="h-3 bg-muted rounded w-1/2" />
    //     </div>
    //   </div>
    // </Card>
  )
}
